import { Expose, plainToInstance, Type } from 'class-transformer';

import { CartProductOptionModel } from '@/entities/cart/model/CartProductOptionModel';
import { ProductModel } from '@/entities/product/model';
import type { CartResponse } from '@/shared/api';

export class CartItemModel {
  @Expose() id: number;

  @Expose({ name: 'created_at' })
  createdAt: string;

  @Expose({ name: 'updated_at' })
  updatedAt: string;

  @Expose({ name: 'is_active' })
  isActive: boolean;

  @Expose({ name: 'product_options' })
  @Type(() => CartProductOptionModel)
  productOptions: CartProductOptionModel[];

  @Expose()
  quantity: number;

  @Expose()
  customer: number;

  @Expose()
  menu: number;

  @Expose({ name: 'product' })
  productId: number;

  product: ProductModel;
}

export const plainToInstanceCartItem = (dto: CartResponse): CartItemModel =>
  plainToInstance(CartItemModel, dto, { excludeExtraneousValues: true });
